import * as Sentry from '@sentry/react';
import type { ScopeContext } from '@sentry/types';

import { BizEventSource, isDynatraceEnabled } from '../dynatrace/constants';
import { dynatraceIntegration } from '../dynatrace/dynatraceIntegration';
import { isSentryEnabled } from '../sentry/initSentry';

type LoggerContext = Pick<Partial<ScopeContext>, 'extra' | 'tags'>;

const extractErrorMessage = (exception: unknown): string => {
	if (exception instanceof Error) return exception.message;
	if (typeof exception === 'string') return exception;
	return String(exception);
};

export const logError = (message: string, passedContext?: LoggerContext) => {
	if (!isSentryEnabled) {
		// eslint-disable-next-line no-console
		console.error(message, passedContext);
	} else {
		const context: Partial<ScopeContext> = { ...passedContext, level: 'error' };
		Sentry.captureMessage(message, context);
	}

	if (isDynatraceEnabled) {
		dynatraceIntegration.sendBizEvent('Error', {
			errorMessage: message,
			eventSource: BizEventSource.Logger,
			...passedContext?.tags,
		});
	}
};

export const logException = (exception: unknown, context?: LoggerContext) => {
	if (!isSentryEnabled) {
		// eslint-disable-next-line no-console
		console.error(exception, context);
	} else {
		Sentry.captureException(exception, context);
	}

	if (isDynatraceEnabled) {
		const errorMessage = extractErrorMessage(exception);

		dynatraceIntegration.sendBizEvent('Error', {
			errorMessage,
			eventSource: BizEventSource.Logger,
			...context?.tags,
		});
	}
};
